var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorinfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.5951C4.31767 14.5951 1.33301 11.6104 1.33301 7.92838C1.33301 4.24639 4.31767 1.26172 7.99967 1.26172C11.6817 1.26172 14.6663 4.24705 14.6663 7.92838C14.6663 11.6097 11.6817 14.5951 7.99967 14.5951ZM7.99967 4.59505C7.82286 4.59505 7.65329 4.66529 7.52827 4.79031C7.40325 4.91534 7.33301 5.08491 7.33301 5.26172V8.59505C7.33301 8.77186 7.40325 8.94143 7.52827 9.06646C7.65329 9.19148 7.82286 9.26172 7.99967 9.26172C8.17649 9.26172 8.34605 9.19148 8.47108 9.06646C8.5961 8.94143 8.66634 8.77186 8.66634 8.59505V5.26172C8.66634 5.08491 8.5961 4.91534 8.47108 4.79031C8.34605 4.66529 8.17649 4.59505 7.99967 4.59505ZM7.99967 11.2617C8.17649 11.2617 8.34605 11.1915 8.47108 11.0665C8.5961 10.9414 8.66634 10.7719 8.66634 10.5951C8.66634 10.4182 8.5961 10.2487 8.47108 10.1236C8.34605 9.99862 8.17649 9.92838 7.99967 9.92838C7.82286 9.92838 7.65329 9.99862 7.52827 10.1236C7.40325 10.2487 7.33301 10.4182 7.33301 10.5951C7.33301 10.7719 7.40325 10.9414 7.52827 11.0665C7.65329 11.1915 7.82286 11.2617 7.99967 11.2617Z",
    fill: "#E94346"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorinfo);
export default __webpack_public_path__ + "static/media/errorinfo.e8f4557c2ca5b7f0972734133311177f.svg";
export { ForwardRef as ReactComponent };